import { Component, ChangeDetectionStrategy, OnInit, Input, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANGUAGE } from '../../constants';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CardComponent implements OnInit {
  @Input() license: any;
  public validFlag = false;
  public tooltipText: string = '';
  constructor(private translate: TranslateService) { }

  public ngOnInit(): void {
    this.translate.setDefaultLang(DEFAULT_LANGUAGE);
    this.translate.use(DEFAULT_LANGUAGE);
    this.translate.use('en-US').subscribe(() => {
      this.setTooltipText();
    });
  }

  public getStatus(): string {
    const now = new Date();
    const validUntil = new Date(this.license.validUntilUtc);
    let validStatus = validUntil >= now ? 'Active' : 'Inactive';
    if (validStatus === 'Active') {
      this.validFlag = true;
    } else {
      this.validFlag = false;
    }
    return validStatus;
  }

  public getFormattedDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }

  public isExpiringSoon(): boolean {
    if (!this.license?.validUntilUtc) return false;
    const today = new Date();
    const validUntil = new Date(this.license.validUntilUtc);
    const timeDiff = validUntil.getTime() - today.getTime();
    const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return daysLeft > 0 && daysLeft <= 7; //check for 1 month instead of 7 days as per latest update
  }

  public getValidUntilDate(): string {
    if (!this.license?.validUntilUtc) return '';
    const date = new Date(this.license.validUntilUtc);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }

  public isExpired(): boolean {
    if (!this.license?.validUntilUtc) return false;
    const today = new Date();
    const validUntil = new Date(this.license.validUntilUtc);
    return today > validUntil;
  }

  public setTooltipText(): void {
    if (!this.license || !this.license.licenseType) {
      this.tooltipText = '';
      return;
    }

    const licenseType = this.license.licenseType.toLowerCase();

    switch (licenseType) {
      case 'gatewayapi':
        this.translate.get('licenses.GATEWAYAPITOOLTIP').subscribe((gwtooltip) => {
          this.tooltipText = gwtooltip
        });
        break;
      case 'bacnet':
        this.translate.get('licenses.BACNETAPITOOLTIP').subscribe((bacnettooltip) => {
          this.tooltipText = bacnettooltip
        });
        break;
      case 'interactpro':
        this.translate.get('licenses.INTERACTPROTOOLTIP').subscribe((interacttooltip) => {
          this.tooltipText = interacttooltip
        });
        break;
      default:
        this.tooltipText = this.translate.instant('licenses.UNKNOWN_LICENSE');
    }
  }

  public getValidIconUrl(): string {
    // Use absolute path from assets for web component compatibility
    return `${environment.webcomponent_endpoint}/assets/images/icons/valid.svg`;
  }
}
